import ContentCreator from './content-creator'

const install = function(Vue, globalOptions) {
  Vue.component('content-creator', ContentCreator)
}
export default { ContentCreator, install }
